import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export const useTabBookmarking = (tabs = [], defaultTab = 0) => {
  const router = useRouter();
  const [activeTab, setActiveTab] = useState(defaultTab);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);

    if (newValue === 0) {
      router.replace(router.asPath.split('#')[0], undefined, {
        shallow: true,
      });
    } else {
      const tabKey = tabs[newValue]?.key;
      if (tabKey) {
        router.replace(`${router.asPath.split('#')[0]}#${tabKey}`, undefined, {
          shallow: true,
        });
      }
    }
  };

  useEffect(() => {
    const getTabIndexFromFragment = (fragment) => {
      const tabIndex = tabs.findIndex((tab) => tab.key === fragment);
      return tabIndex >= 0 ? tabIndex : defaultTab;
    };

    const fragment = window.location.hash.substring(1);
    if (fragment) {
      const tabIndex = getTabIndexFromFragment(fragment);
      setActiveTab(tabIndex);
    }
  }, [tabs, defaultTab]);

  return {
    activeTab,
    handleTabChange,
  };
};

export default useTabBookmarking;
